import { useEffect, useState } from "react";
import {
	onboardingStore,
	selectIsComplete,
	selectSidebarVisible,
	selectChecklistVisible,
} from "../store/onboardingStore";

/**
 * Hook que suscribe un componente al store del onboarding.
 *
 * Devuelve el estado + selectores derivados + acciones. Dispara la carga de la
 * detección al montar (con dedupe y TTL en el store, así que es barato llamarlo
 * desde varios sitios a la vez).
 *
 * @param {boolean} autoload — si true (default), pide la detección al montar.
 */
export function useOnboarding(autoload = true) {
	const [state, setState] = useState(() => onboardingStore.getState());

	useEffect(() => {
		const unsubscribe = onboardingStore.subscribe(setState);
		if (autoload) {
			onboardingStore.ensureLoaded();
		}
		return unsubscribe;
	}, [autoload]);

	return {
		...state,
		isComplete: selectIsComplete(state),
		sidebarVisible: selectSidebarVisible(state),
		checklistVisible: selectChecklistVisible(state),
		refresh: () => onboardingStore.refresh(),
		dismiss: () => onboardingStore.dismiss(),
		setStepComplete: (stepKey, complete) =>
			onboardingStore.setStepComplete(stepKey, complete),
		setShowChecklist: (show) => onboardingStore.setShowChecklist(show),
	};
}

export default useOnboarding;
